import template1 from './1/component';

const templates = {
	1: template1,
};

export default templates;
export function SellerSelector(templateId = 1) {
	return templates[templateId]();
}
